import React from 'react'
import { connect } from 'react-redux'

import { FACILITIES_TYPE, MAXIMUM_NUMBER_OF_USERS, REPORT } from '../../../../helpers'
import IssueReportModal from '../IssueReportModal'
import IssueFileLimitModal from '../IssueFileLimitModal'

import { FacilityManagementStyle } from './styles'

function FacilityManagement(props) {
  const {
    language,
    selectedTab,
    orderManagerTab,
    detailRoom,
  } = props

  const imageBase64 = (detailRoom && detailRoom.image.length > 0)
    && `data:image;base64, ${detailRoom.image[0].image}`

  return (
    <FacilityManagementStyle isImage={Boolean(imageBase64)}>
      {
        imageBase64 && 
        <div className='facility-management__image'>
          {<img alt='room' src={imageBase64}/>}
        </div>
      }

      <div className='facility-management__content'>
        <div className='facility-management__text-box'>
          <h3 className='facility-management__room-name'>
            {detailRoom && detailRoom.roomName}
          </h3>
          <h5 className='facility-management__subtitle'>
            {`${MAXIMUM_NUMBER_OF_USERS[language]} : ${detailRoom && detailRoom.capacity}`}
          </h5>
          <p className='facility-management__information'>
            {detailRoom && detailRoom.information}
          </p>
          <div className='facility-management__divider'/>
        </div>

        <div className='facility-management__facility'>
          <h2 className='facility-management__title'>
            {orderManagerTab[selectedTab].title[language]}
          </h2>
          <div className='facility-management__list'>
            {detailRoom && detailRoom.facility.length > 0 &&
              <table className='table-facilities'>
                <tr>
                  <th className='th-facilities size-70'>
                    {REPORT.FACILITIES.NAME[language]}
                  </th>
                  <th className='th-facilities size-30'>
                    {REPORT.FACILITIES.STATUS[language]}
                  </th>
                </tr>
                {detailRoom.facility.map((item) => {
                  return (
                    <tr>
                      <td className='td-facilities wrap'>{item.itemName}</td>
                      <td
                        className={`td-facilities text-center ${
                          FACILITIES_TYPE[item.status]
                        }`}
                      >
                        {
                          REPORT.FACILITIES.STATUS_NAME[
                            FACILITIES_TYPE[item.status]
                          ][language]
                        }
                      </td>
                    </tr>
                  )
                })}
              </table>
            }
          </div>
        </div>
      </div>

      <IssueReportModal />
      <IssueFileLimitModal />
    </FacilityManagementStyle>
  )
}

const mapStateToProps = ({ accountReducer, meetingReducer, roomReducer }) => {
  return {
    language: accountReducer.language,
    bookingDetail: meetingReducer.bookingDetail,
    detailRoom: roomReducer.detailRoom,
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(FacilityManagement)
